<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <FilterGroup v-model="proppertyFilterOpen"
              :title="$t('servicesystem.common_objects.commonterms.properties')"
              :applied-filters="[statefilter, leadtypesfilter]">
              <LeadStateControl v-model="statefilter" dense edit multiple>
              </LeadStateControl>
              <LeadTypeSelect v-model="leadtypesfilter" multiple clearable externaledit hideIcon class="mt-3">
              </LeadTypeSelect>
            </FilterGroup>

            <v-divider></v-divider>

            <FilterGroup v-model="productFilterOpen" :title="$t('servicesystem.common_objects.machine.product')"
              :applied-filters="[machinetypesfilter, suppliersfilter, modelsfilter]" style="border-top: none;">
              <MachineTypeSelect v-model="machinetypesfilter" multiple clearable externaledit>
              </MachineTypeSelect>
              <SupplierSelect v-model="suppliersfilter" multiple clearable externaledit class="my-3">
              </SupplierSelect>
              <ModelSelect v-model="modelsfilter" multiple clearable externaledit>
              </ModelSelect>
              <AssetTypeSelect v-if="assetTypesEnabled" v-model="assetTypesfilter" multiple clearable externaledit
                class="mt-3">
              </AssetTypeSelect>
            </FilterGroup>

            <FilterGroup v-model="ownershipFilterOpen" :title="$t('servicesystem.common_objects.customer.ownership')"
              :applied-filters="[customersfilter, parentcustomersfilter, customergroupsfilter]">
              <CustomerGroupSelect v-model="customergroupsfilter" multiple clearable externaledit class="mb-3">
              </CustomerGroupSelect>
              <CustomerSelect v-model="parentcustomersfilter"
                :label="$t('servicesystem.common_objects.customer.parent_org')" multiple clearable externaledit
                class="mb-3">
              </CustomerSelect>
              <CustomerSelect v-model="customersfilter" multiple clearable externaledit>
              </CustomerSelect>
            </FilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list :pk="pk">
        <ListPane :getListMethod="getLeadListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="50" ref="ListPane"
          :dialog-trigger="dialogtrigger" :dialogItem="editItem" :dialog-method-config="dialogMethodConfig" :pk="pk">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="setEditItem(item)">
            </ListItem>
          </template>

          <template v-slot:dialog="{ item, trigger, handleadded, handlechanged }">
            <LeadDialog :item="item" :externaltrigger="trigger" @Added="handleadded" @Changed="handlechanged">
            </LeadDialog>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterGroup from "@/components/FilterGroup.vue";
import AssetTypeSelect from "@/components/Inputs/EntityDropdowns/AssetTypeSelect2.vue";
import CustomerGroupSelect from "@/components/Inputs/EntityDropdowns/CustomerGroupSelect2.vue";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import LeadTypeSelect from "@/components/Inputs/EntityDropdowns/LeadTypeSelect2.vue";
import ModelSelect from "@/components/Inputs/EntityDropdowns/MachineModelSelect2.vue";
import MachineTypeSelect from "@/components/Inputs/EntityDropdowns/MachineTypeSelect2.vue";
import SupplierSelect from "@/components/Inputs/EntityDropdowns/SupplierSelect2.vue";
import LeadStateControl from "@/components/LeadStateControl.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import Layout from "@/views/layouts/PreviewableList.vue";
import LeadDialog from "./LeadDialog.vue";
import ListItem from "./LeadsListItem.vue";

export default {
  name: "AdminLeadList",
  props: {},
  components: {
    ListPane,
    FilterPane,
    Layout,
    ListItem,
    LeadDialog,
    FilterGroup,
    CustomerSelect,
    ModelSelect,
    SupplierSelect,
    MachineTypeSelect,
    AssetTypeSelect,
    LeadTypeSelect,
    LeadStateControl,
    CustomerGroupSelect,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "LL-",
      editItem: null,
      dialogtrigger: 1,
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createLead',
        },
        Change: {
          IsClientApiMethod: true,
          Name: 'changeLead',
        },
      },
      proppertyFilterOpen: true,
      productFilterOpen: false,
      ownershipFilterOpen: false,
    };
  },

  mounted() { },

  methods: {
    handleadded: (item) => this.$refs.ListPane.handleadded(item),
    handlechanged: (item) => this.$refs.ListPane.handlechanged(item),

    setEditItem(item) {
      this.dialogtrigger++;
      this.editItem = item;
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          StateList: this.statefilter,
          LeadTypeIdList: this.leadtypesfilter,
          SupplierIdList: this.suppliersfilter,
          MachineTypeIdList: this.machinetypesfilter,
          MachineModelIdList: this.modelsfilter,
          AssetTypeIdList: this.assetTypesfilter,
          CustomerIdList: this.customersfilter,
          ParentCustomerIdList: this.parentcustomersfilter,
          CustomerGroupIdList: this.customergroupsfilter,
        };
        return filters;
      }
      else {
        return null;
      }
    },

    statefilter: {
      get() { return this.getQueryParam("filter-state", [0, 1]); },
      set(update) { this.setQueryParam("filter-state", update); },
    },
    leadtypesfilter: {
      get() { return this.getQueryParam("filter-lead-types", []); },
      set(update) { this.setQueryParam("filter-lead-types", update); },
    },
    machinetypesfilter: {
      get() { return this.getQueryParam("filter-machine-types", []); },
      set(update) { this.setQueryParam("filter-machine-types", update); },
    },
    suppliersfilter: {
      get() { return this.getQueryParam("filter-suppliers", []); },
      set(update) { this.setQueryParam("filter-suppliers", update); },
    },
    modelsfilter: {
      get() { return this.getQueryParam("filter-models", []); },
      set(update) { this.setQueryParam("filter-models", update); },
    },
    assetTypesfilter: {
      get() { return this.getQueryParam("filter-asset-types", []); },
      set(update) { this.setQueryParam("filter-asset-types", update); },
    },
    customersfilter: {
      get() { return this.getQueryParam("filter-customer", []); },
      set(update) { this.setQueryParam("filter-customer", update); },
    },
    parentcustomersfilter: {
      get() { return this.getQueryParam("filter-parent-customer", []); },
      set(update) { this.setQueryParam("filter-parent-customer", update); },
    },
    customergroupsfilter: {
      get() { return this.getQueryParam("filter-customer-group", []); },
      set(update) { this.setQueryParam("filter-customer-group", update); },
    },

    assetTypesEnabled() {
      return this.$store.state.GlobalSettings.Features.AssetTypesEnabled;
    },

    externaltrigger() { return this.$store.state.triggerevents.previewTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem(null); }
  },
};
</script>


<style lang='scss' scoped></style>